import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import './Join.css'

function Join() {
	const [name, setName] = useState('');
    const [room, setRoom] = useState('');

	return (
		<div style={{textAlign: "center"}}>
			<h1>Hello Welocme To Chatter.</h1>
		<div className="joinOuterContainer">
			<div className="JoinInnerContainer">
				<h1 className="heading">Join</h1>
				<div>
					<input
						placeholder="Name"
						type="text"
						name="name"
						className="joinInput"
						onChange={(event) => setName(event.target.value)}
					/>
					<input
						placeholder="Room"
						type="text"
						name="chat"
						className="joinInput mt-20"
						onChange={(event) => setRoom(event.target.value)}
					/>
					<Link onClick={event => (!name || !room)? event.preventDefault(): null} to={`/chat?name=${name}&room=${room}`}>
						<button className="button mt-20" type="submit">
							Sign In.
						</button>
					</Link>
				</div>
			</div>
		</div>
		</div>
	);
}
export default Join;
